import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Bar } from 'react-chartjs-2';
import { Typography, CircularProgress } from '@material-ui/core';
import inverterIco from '../../assets/icons/inverter.png';
import * as stnFastDataReducer from '../../station-fastdata/reducer';
import * as liveStationReducers from '../reducer';

const inverterData = {
    labels: [],
    datasets: [
        {
            label: 'Real-time Inverter',
            backgroundColor: '#59C1BD',
            borderColor: '',
            borderWidth: 0.5,
            hoverBackgroundColor: 'rgba(52, 58, 64, 0.5)',
            data: []
        }
    ],
};

const chartOption = {
    scales: {
        yAxes: [{
            scaleLabel: {
                display: true,
                labelString: 'kWhr'
            }
        }],
        xAxes: [{
            barPercentage: 0.3,
            gridLines: {
                display: false
            }
        }]
    }
};

class InverterInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true
        };
        this.handle_stn_fastdata = this.handle_stn_fastdata.bind(this);
    }

    handle_stn_fastdata() {
        const { history } = this.props;
        history.push(`/station-fastdata`);
    }

    componentDidUpdate(prevProps) {
        const { getRealtimeInverter, getLastFastData } = this.props;

        if (getRealtimeInverter !== prevProps.getRealtimeInverter || getLastFastData !== prevProps.getLastFastData) {
            if (getRealtimeInverter !== "" && getLastFastData !== null && getLastFastData.Data) {
                this.setState({ loading: false });
                this.updateInverterInfo();
            } else {
                this.setState({ loading: true });
            }
        }
    }

    updateInverterInfo() {
        const { getRealtimeInverter, getLastFastData } = this.props;
        const gradient = this.getGradient();
        const realtimeDataInverter = [];
        const finalData = [];
        const inverterLabels = [];

        if (getRealtimeInverter !== "" && getLastFastData !== null && getLastFastData.Data) {
            const arr_string = getRealtimeInverter.split(",");

            for (let x = 0; x < arr_string.length; x++) {
                realtimeDataInverter.push(getLastFastData.Data[arr_string[x]]);
                inverterLabels.push(`Inverter ${x + 1}`);
            }

            if (realtimeDataInverter.filter(inverter => inverter > 100000).length > 0) {
                realtimeDataInverter.forEach(val => finalData.push(val / 10000));
                chartOption.scales.yAxes[0].scaleLabel.labelString = "MWh";
            } else {
                realtimeDataInverter.forEach(val => finalData.push(val / 10));
            }

            inverterData.labels = inverterLabels;
            inverterData.datasets[0].data = finalData;
            inverterData.datasets[0].backgroundColor = gradient;
        }
    }

    getGradient() {
        const ctx = document.createElement('canvas').getContext('2d');
        const gradient = ctx.createLinearGradient(0, 0, 0, 400);
        gradient.addColorStop(0, '#59C1BD');
        gradient.addColorStop(1, '#3E54AC');
        return gradient;
    }

    render() {
        const { loading } = this.state;
        const { getRealtimeInverter } = this.props;

        return (
            <div style={{ padding: '15px', cursor: 'pointer' }} onClick={this.handle_stn_fastdata}>
                {loading ? (
                    <div className="loadingWrapper">
                        <div className="loading">
                            <CircularProgress />
                            <Typography variant="h6">Loading...</Typography>
                        </div>
                    </div>
                ) : getRealtimeInverter === '-1' ? (
                    <div style={{ padding: '18px' }}>
                        <div style={{ textAlign: 'center' }}>
                            <img src={inverterIco} width={100} alt="inv_img"/>
                        </div>
                        <Typography variant="h6"
                            style={{
                                textAlign: 'center',
                                fontWeight: '400',
                                marginTop: '15px'
                            }}> No Inverter Available </Typography>
                    </div>
                ) : (
                    <>
                        <Bar data={inverterData} options={chartOption} />
                    </>
                )}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    getRealtimeInverter: stnFastDataReducer.getRealtimeInverter(state),
    getLastFastData: liveStationReducers.getLastFastData(state),
    getFindStationRealtimeFields: stnFastDataReducer.getFindStationRealtimeFields(state),
});

export default connect(mapStateToProps)(withRouter(InverterInfo));
